import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=ef8aa45a&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=ef8aa45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8aa45a",
  null
  
)

export default component.exports